/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  VestaParameters,
  VestaParametersInterface,
} from "../VestaParameters";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "parameter",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "valueEntered",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxValue",
        type: "uint256",
      },
    ],
    name: "SafeCheckError",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldBonusToSP",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBonusToSP",
        type: "uint256",
      },
    ],
    name: "BonusToSPChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldBorrowingFloorFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBorrowingFloorFee",
        type: "uint256",
      },
    ],
    name: "BorrowingFeeFloorChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldCCR",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newCCR",
        type: "uint256",
      },
    ],
    name: "CCRChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldGasComp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newGasComp",
        type: "uint256",
      },
    ],
    name: "GasCompensationChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldMCR",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newMCR",
        type: "uint256",
      },
    ],
    name: "MCRChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldMaxBorrowingFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newMaxBorrowingFee",
        type: "uint256",
      },
    ],
    name: "MaxBorrowingFeeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldMinNet",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newMinNet",
        type: "uint256",
      },
    ],
    name: "MinNetDebtChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldPercentDiv",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newPercentDiv",
        type: "uint256",
      },
    ],
    name: "PercentDivisorChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "PriceFeedChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "RedemptionBlockRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldRedemptionFeeFloor",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newRedemptionFeeFloor",
        type: "uint256",
      },
    ],
    name: "RedemptionFeeFloorChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_newCap",
        type: "uint256",
      },
    ],
    name: "VstMintCapChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "BORROWING_FEE_FLOOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "REDEMPTION_MAX_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BORROWING_FEE_FLOOR_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "BonusToSP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BonusToSP_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "CCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "CCR_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "MAX_BORROWING_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_BORROWING_FEE_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "MCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MCR_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "MIN_NET_DEBT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_NET_DEBT_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "PERCENT_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PERCENT_DIVISOR_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REDEMPTION_BLOCK_DAY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "REDEMPTION_FEE_FLOOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REDEMPTION_FEE_FLOOR_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "VST_GAS_COMPENSATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VST_GAS_COMPENSATION_DEFAULT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_100pct",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "activePool",
    outputs: [
      {
        internalType: "contract IActivePool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "adminContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultPool",
    outputs: [
      {
        internalType: "contract IDefaultPool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceFeed",
    outputs: [
      {
        internalType: "contract IPriceFeed",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "redemptionBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "removeRedemptionBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "sanitizeParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_activePool",
        type: "address",
      },
      {
        internalType: "address",
        name: "_defaultPool",
        type: "address",
      },
      {
        internalType: "address",
        name: "_priceFeed",
        type: "address",
      },
      {
        internalType: "address",
        name: "_adminContract",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "setAdminContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "setAsDefault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "blockInDays",
        type: "uint256",
      },
    ],
    name: "setAsDefaultWithRemptionBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "newBonusToSP",
        type: "uint256",
      },
    ],
    name: "setBonusToSP",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "borrowingFeeFloor",
        type: "uint256",
      },
    ],
    name: "setBorrowingFeeFloor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "newCCR",
        type: "uint256",
      },
    ],
    name: "setCCR",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "newMCR",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newCCR",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newBonusToSP",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "gasCompensation",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minNetDebt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "precentDivisor",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "borrowingFeeFloor",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxBorrowingFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "redemptionFeeFloor",
        type: "uint256",
      },
    ],
    name: "setCollateralParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "newMCR",
        type: "uint256",
      },
    ],
    name: "setMCR",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "maxBorrowingFee",
        type: "uint256",
      },
    ],
    name: "setMaxBorrowingFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minNetDebt",
        type: "uint256",
      },
    ],
    name: "setMinNetDebt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "precentDivisor",
        type: "uint256",
      },
    ],
    name: "setPercentDivisor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_priceFeed",
        type: "address",
      },
    ],
    name: "setPriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "redemptionFeeFloor",
        type: "uint256",
      },
    ],
    name: "setRedemptionFeeFloor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "gasCompensation",
        type: "uint256",
      },
    ],
    name: "setVSTGasCompensation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_cap",
        type: "uint256",
      },
    ],
    name: "setVstMintCap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "vstMintCap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type VestaParametersConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VestaParametersConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VestaParameters__factory extends ContractFactory {
  constructor(...args: VestaParametersConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<VestaParameters> {
    return super.deploy(overrides || {}) as Promise<VestaParameters>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): VestaParameters {
    return super.attach(address) as VestaParameters;
  }
  override connect(signer: Signer): VestaParameters__factory {
    return super.connect(signer) as VestaParameters__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VestaParametersInterface {
    return new utils.Interface(_abi) as VestaParametersInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VestaParameters {
    return new Contract(address, _abi, signerOrProvider) as VestaParameters;
  }
}
